var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.information
  }, [_c('div', {
    class: _vm.$style.label
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    class: _vm.$style.value
  }, [_vm._v(_vm._s(_vm.value))])]), _c('div', {
    class: _vm.$style.action
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }